import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {AnalyticsVisualization as GQLAnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';
import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';

import {VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME} from '../AnalyticsVisualizationConstants';
import {isVisualizationTypeParameters, VisualizationType} from '../AnalyticsVisualizationTypes';
import {RESTAnalyticsVisualization, RESTOutlierConfig} from '../RESTAnalyticsVisualizationTypes';
import getVisualizationType from './getVisualizationType';

type GQLOutlierConfig = NonNullable<
  ExtractByTypename<
    AnalyticsVisualization['parameters'],
    'AnalyticsVisualizationScatterPlotParametersNode'
  >['outlierConfig']
>;

export function convertGQLToRESTOutlierConfig(gqlOutlierConfig: GQLOutlierConfig): RESTOutlierConfig {
  const {__typename, ...otherParameters} = gqlOutlierConfig;
  return {
    ...otherParameters,
    version: 1,
  };
}

export function convertRESTToGQLOutlierConfig(restOutlierConfig: RESTOutlierConfig): GQLOutlierConfig {
  const {version, ...otherParameters} = restOutlierConfig;
  return {
    ...otherParameters,
    __typename: 'OutlierConfigNode',
  } as GQLOutlierConfig;
}

/**
 * NOTE: the return type is inaccurate and will never include the `regressionType` key.
 */
export function convertGQLToRESTAnalyticsVisualization(
  gqlAnalyticsVisualization: GQLAnalyticsVisualization
): RESTAnalyticsVisualization {
  const {
    __typename: visualizationTypename,
    parameters,
    ...otherVisualizationAttrs
  } = gqlAnalyticsVisualization;
  const {__typename: parametersTypename, ...otherParametersAttrs} = parameters;

  return {
    ...otherVisualizationAttrs,
    type: getVisualizationType(gqlAnalyticsVisualization),
    parameters: {
      ...otherParametersAttrs,
      ...(isVisualizationTypeParameters(parameters, VisualizationType.SCATTER_PLOT) && {
        outlierConfig:
          parameters.outlierConfig == null
            ? null
            : {...convertGQLToRESTOutlierConfig(parameters.outlierConfig)},
      }),
    },
  } as RESTAnalyticsVisualization;
}

export function convertRESTToGQLAnalyticsVisualization(
  restAnalyticsVisualization: RESTAnalyticsVisualization
): GQLAnalyticsVisualization {
  const {parameters, type, ...otherVisualizationAttrs} = restAnalyticsVisualization;
  return {
    ...otherVisualizationAttrs,
    __typename: 'AnalyticsVisualizationNode',
    parameters: {
      ...parameters,
      __typename: VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME[type],
      ...(type === VisualizationType.SCATTER_PLOT && {
        outlierConfig: {
          ...convertRESTToGQLOutlierConfig(restAnalyticsVisualization.parameters.outlierConfig),
        },
      }),
    },
  } as GQLAnalyticsVisualization;
}
